import { FeatureFlag, useFeatureFlag } from "../contexts/launchDarklyContext";

/**
 * Whether report extractions are enabled for the current workspace or user.
 *
 * The flag now gates reachability: the sidebar links and the
 * `report-extraction` routes, via `RequireReportExtractions`. It also still
 * selects the viewer layout inside `ViewReportExtractionPage`.
 *
 * Consequence of gating both on one key: the viewer's `!workpaperEnabled`
 * branches (the pre-project generic layout, the view-mode shortcuts and the
 * per-item delete affordance) are no longer reachable, because the route guard
 * has already proven the flag true before the page mounts. That dead code is
 * left in place deliberately for now; removing it is a follow-up. Do not add
 * new behaviour behind `!workpaperEnabled`, it will never run.
 *
 * Callers that decide routing rather than rendering must wait for
 * `useFeatureFlagsReady()`. This is not merely "false until ready": it reads
 * its fail-closed default until LaunchDarkly's initial fetch resolves, and
 * then the ANONYMOUS context's value until identify completes, so before flags
 * are authoritative it can read either false or true.
 */
export function useSoc1ExtractionWorkpaperEnabled(): boolean {
  return useFeatureFlag(FeatureFlag.soc1ExtractionWorkpaper);
}
